import { parseISO, format } from 'date-fns'

const FootDate = ({datetime, clazz}) => {
    return <div className={clazz}>
                <p>{format(parseISO(datetime), 'yyyy/MM/dd HH:MM:SS')} </p> 
           </div>
}

export default FootDate;